import * as React from 'react'
import { useState } from 'react'
import {
    useParams,
    useHistory,
    Link,
    useRouteMatch
} from 'react-router-dom';
import {
    Accordion,
    AccordionItem,
    AccordionContent,
    AccordionToggle,
} from '@patternfly/react-core';
import {
    Table,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
    TableVariant,
    ExpandableRowContent
} from '@patternfly/react-table';
import {
    ResourceItem,
    ResourceItemVariants,
    ResourceItemType
} from '@app/components/ResourceItem'

import { Namespace, Container } from '@app/SecretManager/SecretsExplorer/model/repository'
import { ContainerPage } from '@app/SecretManager/SecretsExplorer/view/ContainerPage';

const ApplicationPage: React.FunctionComponent<{ namespaces: Namespace[], root: string }> = ({ namespaces, root }) => {

    const history = useHistory();
    const { path, url } = useRouteMatch<{ path: string, url: string }>();
    const [expanded, setExpanded] = useState<string[]>([])

    const { namespace_name, application_name } = useParams<{ namespace_name: string, application_name: string }>();
    const namespace = namespaces.find(n => n.name === namespace_name);
    const application = namespace?.applications.find(a => a.name === application_name);
    if (application === undefined) {
        return <h1>Error</h1>
    }

    const isContainerExpanded = (container: string) => expanded.includes(container);
    const setContainerExpanded = (container: string, isExpanding = true) =>
        setExpanded((prevExpanded) => {
            const otherExpanded = prevExpanded.filter((r) => r !== container);
            const result = isExpanding ? [...otherExpanded, container] : otherExpanded;

            return result;
        });

    const table_body = (containers: Container[]) => {
        return containers.map((container, rowIndex) => {
            return <>
                <Tr>
                    <Td>
                        <ResourceItem type={ResourceItemType.Container}>
                            <Link to={`${url}/${container.name}`}>{container.name}</Link>
                        </ResourceItem>
                    </Td>
                    <Td>{container.kind}</Td>
                </Tr>
            </>
        })
    }

    return <>

        <section className="dx-page-section">
            <nav className="dx-breadcrumb">
                <span className="dx-breadcrumb__item"><Link className="dx-breadcrumb__link" to={`${root}`}>Secret Manager</Link></span>
                <span className="dx-breadcrumb__item"><Link className="dx-breadcrumb__link" to={`${root}/${namespace_name}`}>{namespace_name}</Link></span>
                <span className="dx-breadcrumb__item">Application details</span>
            </nav>
            <ResourceItem variant={ResourceItemVariants.h1} type={ResourceItemType.Application}>{application.name}</ResourceItem>
        </section>
        <hr className="dx-divider" />
        <section className="dx-page-section">
            <h2 className="dx-title">Containers</h2>
            <Table variant={TableVariant.compact}>
                <Thead>
                    <Tr>
                        <Th>Name</Th>
                        <Th>Kind</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {table_body(application.containers)}
                </Tbody>
            </Table>

        </section>
    </>
}

export { ApplicationPage }